import type { HTMLAttributes, TableHTMLAttributes, TdHTMLAttributes } from "react";
import { cx } from "./cx";

/**
 * Data table — the paste-table hero (M3) and accuracy column compose from
 * this. Working-surface density register (space.2–4); headers are micro-caps
 * labels; numeric cells use the mono face with tabular figures.
 */
export function Table({ className, frameClassName, children, ...rest }: TableHTMLAttributes<HTMLTableElement> & { frameClassName?: string }) {
  return (
    <div className={cx("pz-table-frame", frameClassName)}>
      <table className={cx("pz-table", className)} {...rest}>
        {children}
      </table>
    </div>
  );
}

/** Numeric/data cell — mono, tabular-nums, right-aligned. */
export function NumCell({ className, ...rest }: TdHTMLAttributes<HTMLTableCellElement>) {
  return <td className={cx("pz-td--num", className)} {...rest} />;
}

/** Selected-state helper for rows (accent.subtle wash + accent rule). */
export function Row({ selected = false, ...rest }: HTMLAttributes<HTMLTableRowElement> & { selected?: boolean }) {
  return <tr aria-selected={selected || undefined} {...rest} />;
}
